const messages = {
    pageTitle: 'Zlecenia na prototyp',
    menuTitle: 'Zlecenia na prototyp',

    headers: {
        number: 'Numer zlecenia',
        name: 'Nazwa zlecenia',
        customer: 'Klient',
        status: 'Status',
        createdAt: 'Data utworzenia',
        createdBy: 'Utworzone przez',
        actions: 'Akcje'
    },

    actions: {
        details: 'Szczegóły zlecenia',
        closeJob: 'Zamknij zlecenie',
        backToList: 'Powrót do listy',
        sendComment: 'Wyślij'
    },

    closeDialog: {
        title: 'Zamykanie zlecenia',
        content: 'Czy na pewno chcesz zamknąć zlecenie?',
        confirmButton: 'Zamknij'
    },

    detail: {
        pageTitle: 'Zlecenie na prototyp'
    },

    tabs: {
        details: 'Szczegóły',
        attachments: 'Załączniki',
        comments: 'Komentarze'
    },

    details: {
        fields: {
            number: 'Numer zlecenia',
            name: 'Nazwa zlecenia',
            customer: 'Klient',
            status: 'Status',
            createdAt: 'Data utworzenia',
            createdBy: 'Utworzone przez',
            description: 'Uwagi'
        }
    },

    attachments: {
        fileLabel: 'Pliki',
        filePlaceholder: 'Wybierz pliki',
        add: 'Dodaj',
        deleteTitle: 'Usuwanie załącznika',
        deleteContent: 'Czy na pewno chcesz usunąć załącznik: {fileName}?',
        deleteConfirm: 'Usuń',
        deleteTooltip: 'Usuń',
        downloadTooltip: 'Kliknij żeby pobrać',
        noAttachments: 'Nie dodano załączników.',
        maxSizeInfo: 'Dopuszczalny rozmiar pojedynczego pliku: {size} MB',
        maxSizeError: 'Przekroczono dopuszczalny rozmiar pliku: {size} MB.',
        table: {
            fileName: 'Nazwa pliku',
            actions: 'Akcje'
        }
    },

    comments: {
        empty: 'Brak komentarzy.',
        addLabel: 'Dodaj komentarz',
        table: {
            author: 'Autor',
            createdAt: 'Data i godzina dodania',
            content: 'Treść'
        }
    },

    notifications: {
        closeSuccess: 'Zlecenie na prototyp zostało zamknięte.',
        commentCreated: 'Komentarz został dodany.',
        attachmentCreated: 'Załącznik został dodany.',
        attachmentDeleted: 'Załącznik został usunięty.'
    },

    errors: {
        fetchList: 'Pobranie listy zleceń na prototyp nie powiodło się.',
        fetchDetail: 'Pobranie zlecenia na prototyp nie powiodło się.',
        close: 'Zamknięcie zlecenia na prototyp nie powiodło się.',
        fetchComments: 'Pobranie komentarzy nie powiodło się.',
        createComment: 'Dodanie komentarza nie powiodło się.',
        createAttachment: 'Dodanie załącznika nie powiodło się.',
        deleteAttachment: 'Usunięcie załącznika nie powiodło się.'
    }
}

export default {
    messages,
    locale: 'pl'
}
